import React, { useEffect } from "react";
import HeaderInner from "./HeaderInner";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Button, TextField } from "@material-ui/core";
import configureStore from "../../../store/configureStore";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { create_note } from "./actions/action-notes";
import { useDispatch, useSelector } from "react-redux";
import { get_lead, get_lead_details } from "./actions/action-lead";
import Footer from "./Footer";
import { history } from "../../..//reducers";
import CommonSnackBar from "../../common/CommonSnackBar";

const store = configureStore();

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 10,
  },
  input: {
    marginBottom: 10,
    background: "#fff",
    width: "100%",
  },
  Select: {
    marginBottom: 10,
    background: "#fff",
    width: "100%",
  },
  formControl: {
    marginBottom: 10,
    background: "#fff",
    width: "100%",
  },
}));

export default function AddNotes() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { activeOuid, activeOuidChain } = store.getState().permission;
  const { leads } = useSelector((state) => state.lead);
  const { leaddetails } = useSelector((state) => state.lead);

  const [state, setState] = React.useState({
    leadId: "",
    leadContactFullName: "",
    noteContent: "",
  });

  const renderLead = (leadItems) => {
    if (leadItems) {
      return leadItems.map((item) => (
        <MenuItem
          className={classes.MenuItem}
          key={item.id}
          value={item.id}
          data-my-value={item.contactFullName}
        >
          {item.contactFullName}
        </MenuItem>
      ));
    }
  };

  const onSelectChange = (event) => {
    console.log("event", event);
    const { myValue } = event.currentTarget.dataset;
    console.log("Menu click event", myValue);
    setState({
      ...state,
      leadId: event.target.value,
      leadContactFullName: myValue,
    });
    console.log("state", state);
  };

  const handleChange = (event) => {
    console.log("select ", event.target.value);
    console.log("select id ", [event.target.id]);
    setState({ ...state, [event.target.id]: event.target.value });
  };

  const handleSubmit = () => {
    console.log("Handle submit");
    dispatch(create_note(state, activeOuid));
    history.push(`/${activeOuid}/notes`);
  };

  let search = window.location.search;
  let params = new URLSearchParams(search);
  let particularId = params.get("leadid");
  console.log("particularId", particularId);

  useEffect(() => {
    console.log("inuseEffect");
    const fetchData = async (dispatch) => {
      if (particularId) {
        await dispatch(get_lead_details(particularId, activeOuid));
        setState({
          ...state,
          leadId: store.getState().lead.leaddetails.id,
          leadContactFullName:
            store.getState().lead.leaddetails.contactFullName,
        });
      } else {
        await dispatch(get_lead(activeOuid));
      }
    };
    fetchData(dispatch);
  }, [dispatch]);

  return (
    <div>
      <HeaderInner pageTitle="Create Notes" />
      <div className="HrmAppPage container--narrow mt">
        <p className="sub_text">Link Contact*</p>

        <form className="add_wrap" onSubmit={() => handleSubmit()}>
          {particularId ? (
            <TextField
              id="leadContactFullName"
              label="Full Name"
              fullWidth
              required
              disabled
              value={leaddetails && leaddetails.contactFullName}
              variant="outlined"
              className={classes.input}
              onChange={handleChange}
              inputProps={{
                style: {
                  textTransform: "capitalize",
                  color: "#131313",
                },
              }}
            />
          ) : (
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="demo-simple-select-outlined-label">
                Full Name
              </InputLabel>
              <Select
                labelId="demo-simple-select-outlined-label"
                id="leadContactFullName"
                required
                value={state.leadId && state.leadId}
                onChange={onSelectChange}
                label="Full Name"
                className={classes.select}
              >
                {leads && renderLead(leads)}
              </Select>
            </FormControl>
          )}
          <h4 className="form_heading">Take Down Notes </h4>
          <TextField
            id="noteContent"
            label="Description"
            fullWidth
            minRows={8}
            multiline
            variant="outlined"
            required
            className={classes.input}
            onChange={handleChange}
          />
          <div className="AppFloatingButtonWrapper t-c">
            <Button
              className="primary_btn"
              fullWidth
              type="submit"
              variant="contained"
              color="primary"
            >
              Create Notes
            </Button>
          </div>

          {/* <button className="w-100  primary_btn" onClick={() => handleSubmit()}>
            Create Notes
          </button> */}
        </form>
      </div>
      <Footer />
      <CommonSnackBar />
    </div>
  );
}
